
































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import httpApi from "../API/Sys/Menu";
import { getCookie, setCookie } from "../JS/cookie"; //使用getCookie方法
import sliderMenu from "../components/sliderMenu.vue"; //左边二级菜单
import tencentList from "../components/tencentList.vue"; //公众号列表
import HttpClient from "@/API/HttpClient";

@Component({
  components: {
    sliderMenu: sliderMenu,
    tencentList: tencentList
  }
})
export default class mangecenter extends Vue {
  @Provide() sliderKey:string = "";
  @Provide() sliderList: any = [];
  @Provide() menuKey:any = "";
  @Provide() ScanCode: boolean = false; //扫码授权公众号
  @Provide() ScanCodeSrc: string = ""; //扫码的url
  @Provide() TenantId: any = 0;

  // 监听侧边栏KEY变化
  get sliderCode(){
    return this.$store.state.NavsInfoStore.slidebarKey;
  }
  @Watch('sliderCode',{ immediate: false, deep: true })
  onsliderCode(val: string, oldVal: string) {
    console.log("appaccount监听侧边栏变化: ");
    if(val){
      this.sliderKey = val;
    }
  }

  /**
   * 生命周期，初始化加载数据
   */
  created(){
    let _this = this;
    // 已绑定公众号
    if(this.$store.state.TencentInfoStore.typeCode != '-1'){
      if(this.$route.params.parentcode){
        this.menuKey = this.$route.params.parentcode;
      }else{
        this.menuKey = localStorage.getItem("menuKey");
      }
      if(_this.$store.state.NavsInfoStore.slidebarKey == ""){
        _this.sliderKey = localStorage.getItem("slideKey") as any;
      }else{
        _this.sliderKey = _this.$store.state.NavsInfoStore.slidebarKey;
      }
    }
    window.addEventListener("beforeunload",()=>{}) // 页面刷新前
    
    this.TenantId = getCookie("TenantID");
    this.ScanCodeSrc =
      HttpClient.ServerWxHost() +
      "/OpenWeiXin.html?tenantid=" +
      this.TenantId +
      "&" +
      Math.random();
  }

  topage() {
    this.$store.commit("SetMenuKey", "M160");
    localStorage.setItem("menuKey", "M160");
    this.$router.push({
      name: "/markting/personalizedMenu/list",
      params: { parentcode: "M160" }
    });
    
  }
  //对话框关闭
  handleDialogClose() {
    this.ScanCode = false;
    this.ScanCodeSrc = this.ScanCodeSrc + Math.random();
  }
  ScanCodeclick() {
    if (this.TenantId == 0) {
      this.$message.error("请联系系统管理授权权限！");
      return;
    }
    this.ScanCode = true;
    this.ScanCodeSrc = this.ScanCodeSrc + Math.random();
  }

}
